import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import { basePaymentMethodModel } from "@/feature-wallet/models/any-payment-method.mjs";
import { cardBrandModel } from "@/feature-wallet/models/card-brand.mjs";

export const stripeCardPaymentMethodModel = {
  ...basePaymentMethodModel,

  providerType: "STRIPE" as const,
  type: "card" as const,

  cardBrand: cardBrandModel,
  cardExpiryMonth: Number,
  cardExpiryYear: Number,
  cardLast4: String,
  billingPostalCode: String,
} satisfies ModelDefinition;

export interface StripeCardPaymentMethod
  extends FromModel<typeof stripeCardPaymentMethodModel> {}
